'use client';
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useReporter } from '../../reporter';
import { getPlainText } from '../../cms/RichText/getPlainText';
import { StyledMuxPlayer } from './styles.js';
import { videoPlaying } from './events';
import { guardMuxPlay } from './guardMuxPlay.js';

// Module scope, not an effect: `loadstart` can fire before effects flush.
guardMuxPlay().catch(() => {});

export const MuxVideo = ({
  playbackId,
  autoplay,
  loop,
  thumbnail,
  showScrollControls = false,
  aspectRatio = '4 / 3',
  parentHeading = '',
}) => {
  const reporter = useReporter();
  const viewVideoReported = useRef(false);

  const reportVideoViewed = () => {
    if (!viewVideoReported.current)
      reporter.tag(videoPlaying(getPlainText(parentHeading)));
    viewVideoReported.current = true;
  };

  return (
    <StyledMuxPlayer
      showScrollControls={showScrollControls}
      playbackId={playbackId}
      aspectRatio={aspectRatio}
      loop={loop}
      autoPlay={autoplay}
      muted={autoplay}
      preload="auto"
      minResolution="540p"
      {...(thumbnail ? { poster: thumbnail } : {})}
      onPlaying={() => reportVideoViewed()}
    />
  );
};

MuxVideo.propTypes = {
  playbackId: PropTypes.string.isRequired,
  autoplay: PropTypes.bool,
  loop: PropTypes.bool,
  thumbnail: PropTypes.string,
  showScrollControls: PropTypes.bool,
  aspectRatio: PropTypes.string,
  parentHeading: PropTypes.node,
};
